import { createTheme } from "@mui/material/styles";

const heatReportStyles = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          padding: "6px 12px !important",
          fontSize: "0.7rem !important",
          borderRadius: 4,
          lineHeight: 1.5,
        },
      },
    },
    MuiButtonGroup: {
      styleOverrides: {
        root: {
          "& .MuiButtonGroup-grouped": {
            minWidth: 30,
            padding: "4px 4px !important",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontSize: "clamp(.7rem, 0.8rem, 1rem)",
          "& .MuiInputBase-root": {
            // Remove fixed height for multiline
            minHeight: "35px !important",
            padding: "4px 0px 4px 2px !important",
          },
          "& .MuiOutlinedInput-input": {
            padding: "4px 0px 4px 4px !important",
            fontSize: "clamp(.7rem, 0.8rem, 1rem) !important",
          },
          "& label": {
            fontSize: "0.75rem !important",
          },
          // Add styles for multiline input
          "& .MuiOutlinedInput-multiline": {
            padding: "8px 14px !important",
          },
          // STYLES FOR HOVER, FOCUS, AND INTERACTION ON ENABLED TEXTFIELDS (Outlined Variant)
          "& .MuiOutlinedInput-root:not(.Mui-disabled)": {
            "&:hover": {
              cursor: "default", // Cursor for the entire component on hover
              "&:not(.Mui-focused) .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(0, 0, 0, 0.23)",
              },
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(0, 0, 0, 0.23)",
              borderWidth: "1px",
            },
            "& .MuiOutlinedInput-input": {
              cursor: "default !important", // Ensure default cursor on the input itself
              caretColor: "transparent !important", // Hide the blinking caret
              userSelect: "none", // Standard syntax
              MozUserSelect: "none", // Firefox
              WebkitUserSelect: "none", // Chrome, Safari, Opera
              msUserSelect: "none", // Internet Explorer/Edge
            },
          },
        },
      },
    },
    // New table-related styles
    MuiTable: {
      styleOverrides: {
        root: {
          minWidth: 300,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: 4,
          "&.narrow": {
            whiteSpace: "nowrap",
            maxWidth: "80px",
          },
        },
        head: {
          fontWeight: "bold",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: ({ theme }) => ({
          "&:nth-of-type(odd)": {
            backgroundColor: `${theme.palette.grey[100]} !important`,
          },
        }),
      },
    },

    MuiFormControl: {
      styleOverrides: {
        root: {
          margin: "2px 0",
          width: "100%", // Ensure it takes full width of its container
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          transform: "translate(14px, 12px) scale(1)",
          "&.MuiInputLabel-shrink": {
            transform: "translate(14px, -6px) scale(0.75)",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          height: "35px",
        },
        input: {
          padding: "8px 14px !important",
          height: "19px !important", // Adjust this to match other inputs
          fontSize: "clamp(.7rem, 0.8rem, 1rem) !important",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          height: "35px !important",
          lineHeight: "35px !important",
          paddingTop: 0,
          paddingBottom: 0,
          "&.MuiOutlinedInput-root": {
            paddingRight: "32px !important", // Space for the dropdown icon
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: "0.7rem",
          minHeight: "35px",
          lineHeight: "35px !important",
        },
      },
    },
  },
});

export default heatReportStyles;
